import React from "react";

export default function DocIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 25"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="currentColor" clipPath="url(#a)">
        <path
          d="M8.2276 10.3181C8.12714 9.91625 7.71994 9.67193 7.31809 9.77239C6.91625 9.87285 6.67193 10.28 6.77239 10.6819L9.02239 19.6819C9.10514 20.0129 9.40086 20.2463 9.74202 20.25C10.0832 20.2536 10.3838 20.0265 10.4736 19.6973L12 14.1004L13.5264 19.6973C13.6162 20.0265 13.9168 20.2536 14.258 20.25C14.5991 20.2463 14.8949 20.0129 14.9776 19.6819L17.2276 10.6819C17.3281 10.28 17.0837 9.87285 16.6819 9.77239C16.2801 9.67193 15.8728 9.91625 15.7724 10.3181L14.2184 16.5339L12.7236 11.0527C12.6346 10.7264 12.3382 10.5 12 10.5C11.6618 10.5 11.3654 10.7264 11.2764 11.0527L9.78155 16.5339L8.2276 10.3181Z" />
        <path
          d="M21 21V6.75L14.25 0H6C4.34315 0 3 1.34314 3 3V21C3 22.6569 4.34315 24 6 24H18C19.6569 24 21 22.6569 21 21ZM14.25 4.5C14.25 5.74264 15.2574 6.75 16.5 6.75H19.5V21C19.5 21.8284 18.8284 22.5 18 22.5H6C5.17157 22.5 4.5 21.8284 4.5 21V3C4.5 2.17157 5.17157 1.5 6 1.5H14.25V4.5Z" />

      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 .082h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
